import { ProductInfo } from "modules/products";

const ProductInfoPage = () => {
  return <ProductInfo />;
};

export default ProductInfoPage;
